import { PushPin } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { bool, number } from 'prop-types';
import React, { memo } from 'react';
import connector from './connector';

const badgeSx = {
  p: '3px',
  minWidth: 20,
  height: 20,
  ml: 1.25,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  lineHeight: '1em',
  bgcolor: 'primary.dark',
  borderRadius: '100px',
  textAlign: 'center',
  fontSize: '10px',
  color: theme => theme.palette.white,
  boxShadow: '0 1px 5px 0 rgba(36, 202, 165, 0.2)',
};

const noBadgeSx = {
  ml: 0,
  width: 0,
  display: 'flex',
};

const MessagesBadge = ({
  isCompanyAdmin,
  messagesUnreadCount: rawMessages = 0,
  mandatoriesUnreadCount: rawMandatories = 0,
  pinned,
}) => {
  const messagesUnreadCount = Math.max(0, rawMessages);
  const mandatoriesUnreadCount = Math.max(0, rawMandatories);

  if (!pinned && !(messagesUnreadCount + mandatoriesUnreadCount))
    return <Box component="span" sx={noBadgeSx} />;

  if (isCompanyAdmin) {
    if (!messagesUnreadCount)
      return pinned ? (
        <PushPin color="disabled" fontSize="small" />
      ) : (
        <Box component="span" sx={noBadgeSx} />
      );

    return (
      <Box component="span" sx={badgeSx}>
        {messagesUnreadCount}
      </Box>
    );
  }

  if (!(messagesUnreadCount + mandatoriesUnreadCount))
    return pinned ? (
      <PushPin color="disabled" fontSize="small" />
    ) : (
      <Box component="span" sx={noBadgeSx} />
    );

  return (
    <Box component="span" sx={badgeSx}>
      {messagesUnreadCount + mandatoriesUnreadCount}
    </Box>
  );
};

MessagesBadge.propTypes = {
  messagesUnreadCount: number,
  mandatoriesUnreadCount: number,
  isCompanyAdmin: bool.isRequired,
  pinned: bool.isRequired,
};
const isEqual = (prev, next) => {
  if (prev.pinned !== next.pinned) return false;
  if (prev.messagesUnreadCount !== next.messagesUnreadCount) return false;
  if (prev.mandatoriesUnreadCount !== next.mandatoriesUnreadCount) return false;
  return prev.isCompanyAdmin === next.isCompanyAdmin;
};

export default connector(memo(MessagesBadge, isEqual));
